<div class="modern-page-container">
    <div style="max-width: 800px; margin: 0 auto; padding: 60px 20px;">
        <div style="text-align: center; margin-bottom: 40px;">
            <!-- Show success icon for success, error icon for errors -->
            <div style="margin-bottom: 24px;">
                <em class="fa fa-5x"
                    [ngClass]="{
                        'fa-check-circle': !isError,
                        'fa-times-circle': isError
                    }"
                    [style.color]="isError ? '#d13438' : '#107c10'"></em>
            </div>

            <h2 style="color: #323130; font-size: 32px; font-weight: 600; margin-bottom: 16px;">{{title}}</h2>
            <p style="color: #605e5c; font-size: 16px; line-height: 1.5; margin-bottom: 0;">{{message}}</p>
        </div>

        <!-- Show additional instruction for delegate approvals -->
        <div *ngIf="isDelegateApproval && !isError" class="info-callout" style="text-align: center;">
            <div class="info-callout-title">
                <i class="fa fa-info-circle"></i> Next Step
            </div>
            <div class="info-callout-text">
                Please contact <strong>{{onboardingUserEmail}}</strong>
                and let them know that the approval is complete. They can now continue their setup process.
            </div>
        </div>

        <!-- Download link if present -->
        <div *ngIf="downloadUrl" style="text-align: center; margin-top: 32px;">
            <a [href]="downloadUrl" kendoButton themeColor="primary">
                {{downloadText}}
            </a>
        </div>
    </div>
</div>
